import { Line } from '@slides/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { ScriptHeader } from '../styles';

export const SectionOne = () => {
    const { t } = useTranslation();

    return (
        <>
            <ScriptHeader>
                {t('modification.script.title')}
            </ScriptHeader>
            <Line />
            <div>
                {t('modification.script.1')}
            </div>
            <h4>{t('modification.script.2')}</h4>
            <div>
                {t('modification.script.3')}
            </div>
            <h4>{t('modification.script.4')}</h4>
            <div>
                {t('modification.script.5')}
            </div>
       </>
    );
};
